import { render, staticRenderFns } from "./WorkshopGridCpt.vue?vue&type=template&id=8bfba5ce&"
import script from "./WorkshopGridCpt.vue?vue&type=script&lang=ts&"
export * from "./WorkshopGridCpt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports